module.exports = "/_next/static/images/vomero_top-9fbafcad4f8e57e4a9261bebfa659740.jpg";